<div class="card mt-5" *ngIf="this.cardItemCount > 0">
  <div *ngIf="IsWaiting">
    <div class="backdrop">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-6">
        <h4 class="title">Save for Later</h4>
      </div>
      <div class="col-md-6 pull-right" style="text-align: right;">
        <span>{{this.cardItemCount}}</span> Items
      </div>
    </div>
    <hr>
    <ng-container>
      <div class="col">
        <div class="col" *ngFor="let p of this.Model" [attr.data-testid]="'saved-cart-item-' + p.Webcode">
          <!--Product row-->
          <div class="row d-flex p-2">
            <div class="col" *ngIf="p.ParentRecordID"></div>
            <div class="col-lg-2 col-md-3 col-sm-3 col-xs-4">
              <h6 class="font-weight-bold mb-3">Product</h6>
              <img src="{{getImageURL(p.ImageDataburst)}}" class="img-fluid" />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-9 col-xs-12">
              <h6 class="font-weight-bold mb-3">Description</h6>
              <div>
                <small> {{p.Description}}</small><br />
                <small class="text-muted">
                  {{p.UnitPrice|currency}}
                  <strong class="red-text" *ngIf="p.Attributes.RegularPrice-p.UnitPrice> 0">
                    SAVE {{p.Attributes.RegularPrice - p.UnitPrice|currency}}
                  </strong><br />
                  Webcode: {{p.Webcode}}
                </small>
              </div>
              <div
                *ngIf="p.IsDigitalItem"
                class="badge green"
                triggers="hover"
                placement="right"
                container="body"
                mdbPopoverHeader="Digital Item"
                mdbPopover="This item is digital. It will be delivered via email."
              >
                Digital Item <i class="fas fa-question-circle"></i>
              </div>
            </div>
            <div class="col" *ngIf="!p.ParentRecordID"
                 style="padding-right: 5px !important;padding-left: 5px !important;">
              <div class="font-weight-bold mb-3">
                <i class="fa fa-check text-success" *ngIf="p.StockingStatus === 'In Stock'"></i>
                <span *ngIf="p.FinalSale" class="badge red hand" triggers="hover" placement="top" container="body"
                      mdbPopoverHeader="Special Order:"
                      mdbPopover="Special Order items are ordered from the manufacturer and may take weeks to arrive. It requires a full, non-refundable payment.">
                  Special
                  order <i class="fas fa-info-circle"></i>
                </span>
                <span *ngIf="!p.FinalSale" style="width:220px !important;"> {{ p.StockingStatus}}</span>
              </div>
              <small *ngIf="p.StockingStatus === 'In Stock'">Ready to Ship</small>
            </div>
          </div>
          <!-- Product Row  buttons -->
          <div class="row d-flex  border-bottom" style="padding-bottom: 10px;">

            <div class="col-6 d-flex justify-content-start">
              <div class="small hand btnItem" (click)="removeItem(p)" data-testid="remove-saved-for-later">
                <mdb-icon far icon="trash-alt"></mdb-icon> Remove
              </div>
            </div>
            <div class="col-6 d-flex justify-content-end" *ngIf="!p.ParentRecordID">
              <div class="small hand btnItem" (click)="moveItemToCart(p)">
                <i class="fas fa-cart-arrow-down" data-testid="move-saved-for-later-to-cart"></i> Move to Cart
              </div>
            </div>
            <br>
          </div>
        </div>
      </div>
    </ng-container>

  </div>
</div>
